// extracted by mini-css-extract-plugin
export default {"homecard_txt":"styles_homecard_txt__hjWtW","home_btn_container":"styles_home_btn_container__AR0wQ","home_store_btn":"styles_home_store_btn__c5qLZ"};